import {
  TaxInclusive,
  TaxInclusiveText,
} from 'domains/models/tax_rate/tax_inclusive';
import { TaxType } from 'domains/models/tax_rate/tax_type';
import { z } from 'zod';

export const TaxTypeEnum = z.nativeEnum(TaxType);
export const TaxInclusiveEnum = z.nativeEnum(TaxInclusive);
export const TaxInclusiveTextEnum = z.nativeEnum(TaxInclusiveText);
